import { observer } from 'mobx-react-lite'
import {
  type IDropOptions,
  type IInboxTreeCombine,
  type INodeModel,
  TreeRootInboxes,
} from 'entities/Inbox'
import { MenuSectionTree } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/MenuSectionTree/MenuSectionTree.tsx'
import { useConversationMenuContext } from 'pages/conversations/ui/ConversationMenu/context'
import { SkeletonMenuSection } from 'pages/conversations/ui/ConversationMenu/ui/ConversationMenuInboxes/SkeletonMenuSection/SkeletonMenuSection.tsx'

type IMenuSimpleInboxesProps = {
  onDrop: (
    items: INodeModel<IInboxTreeCombine>[],
    options: IDropOptions<IInboxTreeCombine>,
    dropRoot: TreeRootInboxes
  ) => void
  onClickItem: () => void
}

export const MenuSimpleInboxes = observer(({ onDrop, onClickItem }: IMenuSimpleInboxesProps) => {
  const store = useConversationMenuContext()
  const { simpleMenuStore } = store
  const { loading, selectInboxesCount, hideInboxes } = simpleMenuStore

  const itemsInboxesCount = selectInboxesCount
  const hideSimpleInboxes = hideInboxes

  if (loading) {
    return <SkeletonMenuSection items={[40, 56, 64]} withTitle />
  }

  if (hideSimpleInboxes) return null

  return (
    <MenuSectionTree
      items={simpleMenuStore.items}
      count={itemsInboxesCount}
      title='Inboxes'
      root={TreeRootInboxes.SIMPLE}
      handleDrop={onDrop}
      onClickItemTree={onClickItem}
      useSearch={{
        handleSearch: simpleMenuStore.handleUpdateSearch,
        search: simpleMenuStore.search,
        placeholder: 'Search inboxes',
        autofocus: true,
        variant: 'transparent',
      }}
    />
  )
})
